export default __webpack_public_path__ + "static/media/fix_footer_bg_m.b695d326.png";